import { useTranslation } from 'react-i18next';
import StaggerReveal from '../../../components/feature/StaggerReveal';

export default function WhyInnoflex() {
  const { t } = useTranslation();

  const reasons = [
    { icon: 'ri-flashlight-line', title: t('why_r1_title'), desc: t('why_r1_desc') },
    { icon: 'ri-shield-check-line', title: t('why_r2_title'), desc: t('why_r2_desc') },
    { icon: 'ri-customer-service-2-line', title: t('why_r3_title'), desc: t('why_r3_desc') },
    { icon: 'ri-money-dollar-circle-line', title: t('why_r4_title'), desc: t('why_r4_desc') },
    { icon: 'ri-settings-4-line', title: t('why_r5_title'), desc: t('why_r5_desc') },
    { icon: 'ri-thumb-up-line', title: t('why_r6_title'), desc: t('why_r6_desc') },
  ];

  const stats = [
    { value: '90%', label: t('why_stat_errors'), color: '#00cfff' },
    { value: '8hrs', label: t('why_stat_hours'), color: '#00ff9d' },
    { value: '48h', label: t('why_stat_setup'), color: '#00cfff' },
    { value: '24/7', label: t('why_stat_support'), color: '#00ff9d' },
  ];

  return (
    <section id="why" className="bg-navy-950 py-14 md:py-24 px-5 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">

          {/* Left column */}
          <div>
            <span className="inline-block text-electric text-xs md:text-sm font-semibold tracking-widest uppercase font-body mb-2 md:mb-3">{t('why_label')}</span>
            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
              {t('why_title')}<br />
              {t('why_title_mid')} <span style={{ background: 'linear-gradient(90deg, #00cfff, #00ff9d)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{t('why_title_accent')}</span>
            </h2>
            <p className="font-body text-white/55 text-sm md:text-base leading-relaxed mb-6 md:mb-8">
              {t('why_sub')}
            </p>

            <StaggerReveal
              className="grid grid-cols-2 gap-3 md:gap-4"
              staggerDelay={100}
            >
              {stats.map((stat) => (
                <div key={stat.label} className="bg-navy-800 border border-navy-600 rounded-xl p-3.5 md:p-5 transition-all duration-300 hover:border-electric/40 hover:-translate-y-0.5">
                  <div className="font-heading text-xl md:text-3xl font-bold mb-0.5 md:mb-1" style={{ color: stat.color }}>{stat.value}</div>
                  <div className="font-body text-xs md:text-sm text-white/55">{stat.label}</div>
                </div>
              ))}
            </StaggerReveal>
          </div>

          {/* Right column - reasons */}
          <StaggerReveal
            className="grid grid-cols-2 gap-3 md:gap-4"
            staggerDelay={80}
          >
            {reasons.map((r) => (
              <div
                key={r.title}
                className="bg-navy-800 border border-navy-600 hover:border-electric/40 hover:-translate-y-0.5 rounded-xl p-4 md:p-5 transition-all duration-300 cursor-default"
              >
                <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-electric/15 text-electric mb-2 md:mb-3">
                  <i className={`${r.icon} text-base md:text-lg`}></i>
                </div>
                <h3 className="font-heading text-xs md:text-sm font-bold text-white mb-0.5 md:mb-1">{r.title}</h3>
                <p className="font-body text-[11px] md:text-xs text-white/50 leading-relaxed">{r.desc}</p>
              </div>
            ))}
          </StaggerReveal>
        </div>
      </div>
    </section>
  );
}
